
import {Component, Vue, Watch} from "vue-property-decorator";
import SayfaAciklama from "@/components/SayfaAciklama.vue";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {OfisProUyarilar, OfisProUyarilarLabel} from "@/enum/OfisProUyarilar";
import {Task} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {TaskTuru} from "@/plugins/uyap-plugin/enum/TaskTuru";

interface WarningNode {
  id: number;
  name: string;
  children: WarningNode[];
}

interface TableHeader {
  text: string;
  value?: string;
  align?: string;
  sortable?: boolean;
  class?: string;
}

@Component({
  components: {SayfaAciklama},
})
export default class OfisProUyarilarView extends Vue {
  search = "";
  selectedWarningId: number = OfisProUyarilar.adresArastirmaYapilacaklar;
  secilenDosyalar: any[] = [];
  tableItems: any[] = [];
  stats: any = {};
  currentPage = 1;
  totalItems = 0;
  itemsPerPage = 20;
  sortBy = "";
  sortDesc = false;
  lastLoadedPage = 0;
  currentWarningType = "";
  loading = false;
  activeCategoryId: number | null = null;
  panel: number | null = null;

  private requestSerial = 0;
  private searchTimer: number | null = null;

  readonly items: WarningNode[] = [
    {
      id: OfisProUyarilar.tebligatUyarilari,
      name: OfisProUyarilarLabel[OfisProUyarilar.tebligatUyarilari],
      children: [
        this.warningNode(OfisProUyarilar.adresArastirmaYapilacaklar),
        this.warningNode(OfisProUyarilar.barkodSorgusuVeTebligatBilgisi),
        this.warningNode(OfisProUyarilar.dosyaninKesinlestirilmesiTalebi),
        this.warningNode(OfisProUyarilar.gonderildigiTarihGirilecekler),
        this.warningNode(OfisProUyarilar.hacizTalebindeBulunulacakDosyalar),
        this.warningNode(OfisProUyarilar.itirazinIptaliKaldirilmasiDavasi),
        this.warningNode(OfisProUyarilar.malBeyanindaBulunmamaDavasi),
        this.warningNode(OfisProUyarilar.mernisAdresineTebligat),
        this.warningNode(OfisProUyarilar.mersisAdresineTebligat),
        this.warningNode(OfisProUyarilar.otuzBeseGoreTebligat),
        this.warningNode(OfisProUyarilar.yirmiBireGoreTebligat),
      ],
    },
    {
      id: OfisProUyarilar.hacizUyarilari,
      name: OfisProUyarilarLabel[OfisProUyarilar.hacizUyarilari],
      children: [
        this.warningNode(OfisProUyarilar.haczeGidilecekDosyalar),
        this.warningNode(OfisProUyarilar.hacizTarihiGirilecekDosyalar),
        this.warningNode(OfisProUyarilar.seksenDokuzIkiIhbarnamesi),
        this.warningNode(OfisProUyarilar.seksenDokuzUcIhbarnamesi),
        this.warningNode(OfisProUyarilar.maasHacziMuzekkeresi),
        this.warningNode(OfisProUyarilar.muzekkereTebligiKontrol),
        this.warningNode(OfisProUyarilar.yuzUcDavetiyesi),
        this.warningNode(OfisProUyarilar.kiymetTakdiriIstenecekler),
      ],
    },
    {
      id: OfisProUyarilar.islemsizliktenDusecekDosyalar,
      name: OfisProUyarilarLabel[OfisProUyarilar.islemsizliktenDusecekDosyalar],
      children: [],
    },
  ];

  private readonly warningTypeMap: {[key: number]: string} = {
    [OfisProUyarilar.adresArastirmaYapilacaklar]: "adres-arastirma",
    [OfisProUyarilar.barkodSorgusuVeTebligatBilgisi]: "barkod-sorgusu",
    [OfisProUyarilar.dosyaninKesinlestirilmesiTalebi]: "kesinlestirme",
    [OfisProUyarilar.gonderildigiTarihGirilecekler]: "gonderildigi-tarih",
    [OfisProUyarilar.hacizTalebindeBulunulacakDosyalar]: "haciz-talebinde-bulunulacak-dosyalar",
    [OfisProUyarilar.itirazinIptaliKaldirilmasiDavasi]: "itiraz-davasi",
    [OfisProUyarilar.malBeyanindaBulunmamaDavasi]: "mal-beyani",
    [OfisProUyarilar.mernisAdresineTebligat]: "mernis",
    [OfisProUyarilar.mersisAdresineTebligat]: "mersis",
    [OfisProUyarilar.otuzBeseGoreTebligat]: "35-e-gore",
    [OfisProUyarilar.yirmiBireGoreTebligat]: "21-e-gore",
    [OfisProUyarilar.haczeGidilecekDosyalar]: "hacze-gidilecek-dosyalar",
    [OfisProUyarilar.hacizTarihiGirilecekDosyalar]: "haciz-tarihi-girilecek-dosyalar",
    [OfisProUyarilar.seksenDokuzIkiIhbarnamesi]: "89-2-ihbarnamesi-gonderilecekler",
    [OfisProUyarilar.seksenDokuzUcIhbarnamesi]: "89-3-ihbarnamesi-gonderilecekler",
    [OfisProUyarilar.maasHacziMuzekkeresi]: "maas-haczi-muzekkeresi-gonderilecekler",
    [OfisProUyarilar.muzekkereTebligiKontrol]: "muzekkere-tebligi-kontrol-edilecekler",
    [OfisProUyarilar.yuzUcDavetiyesi]: "103-davetiyesi-gonderilecekler",
    [OfisProUyarilar.kiymetTakdiriIstenecekler]: "kiymet-takdiri-istenecekler",
    [OfisProUyarilar.islemsizliktenDusecekDosyalar]: "islemsizlikten-dusecek-dosyalar",
  };

  private readonly dateHeaderMap: {[key: number]: string} = {
    [OfisProUyarilar.adresArastirmaYapilacaklar]: "Bila Tarihi",
    [OfisProUyarilar.barkodSorgusuVeTebligatBilgisi]: "Tebligat Gönderim Tarihi",
    [OfisProUyarilar.dosyaninKesinlestirilmesiTalebi]: "Tebliğ Tarihi",
    [OfisProUyarilar.hacizTalebindeBulunulacakDosyalar]: "Kesinleşme Tarihi",
    [OfisProUyarilar.itirazinIptaliKaldirilmasiDavasi]: "İtirazın Tebliğ Tarihi",
    [OfisProUyarilar.malBeyanindaBulunmamaDavasi]: "Tebliğ Tarihi",
    [OfisProUyarilar.mernisAdresineTebligat]: "Bila Tarihi",
    [OfisProUyarilar.mersisAdresineTebligat]: "Bila Tarihi",
    [OfisProUyarilar.otuzBeseGoreTebligat]: "Bila Tarihi",
    [OfisProUyarilar.yirmiBireGoreTebligat]: "Bila Tarihi",
    [OfisProUyarilar.haczeGidilecekDosyalar]: "Haciz Tarihi",
    [OfisProUyarilar.hacizTarihiGirilecekDosyalar]: "Talep Tarihi",
    [OfisProUyarilar.seksenDokuzIkiIhbarnamesi]: "89-1 İhbarnamesi Tebliğ Tarihi",
    [OfisProUyarilar.seksenDokuzUcIhbarnamesi]: "89-2 İhbarnamesi Tebliğ Tarihi",
    [OfisProUyarilar.maasHacziMuzekkeresi]: "Talep Tarihi",
    [OfisProUyarilar.muzekkereTebligiKontrol]: "Müzekkere Gönderim Tarihi",
    [OfisProUyarilar.yuzUcDavetiyesi]: "Fiilen Haciz Tarihi",
    [OfisProUyarilar.kiymetTakdiriIstenecekler]: "Haciz Tarihi",
  };

  get warningOptions(): WarningNode[] {
    const warnings: WarningNode[] = [];
    this.items.forEach((category) => {
      if (category.children.length > 0) {
        warnings.push(...category.children);
      } else {
        warnings.push(category);
      }
    });
    return warnings;
  }

  get headers(): TableHeader[] {
    const headers: TableHeader[] = [
      {text: "Dosya No", value: "dosya_esas_no"},
      {text: "Borçlu", value: "borclu_adi"},
      {text: "İcra Dairesi", value: "icra_dairesi"},
      {text: "Uyarı", value: "message"},
    ];

    if (this.selectedWarningId === OfisProUyarilar.islemsizliktenDusecekDosyalar) {
      headers.push(
          {text: "Son İşlem Tarihi", value: "son_islem_tarihi"},
          {text: "Geçen Gün", value: "gecen_gun_sayisi"},
      );
    } else if (this.dateHeaderMap[this.selectedWarningId]) {
      headers.push({
        text: this.dateHeaderMap[this.selectedWarningId],
        value: "tarih",
      });
    }

    headers.push({
      text: "İşlemler",
      value: "actions",
      align: "end",
      sortable: false,
      class: "islemler-header",
    });

    return headers;
  }

  get excelHeaders(): {[key: string]: string} {
    const fields: {[key: string]: string} = {};
    this.headers.forEach((header) => {
      if (header.value && header.value !== "actions") {
        fields[header.text] = header.value;
      }
    });
    return fields;
  }

  get excelData(): any[] {
    return this.exportItems.map((item) => ({
      ...item,
      tarih: item.tarih ? this.$helper.tarihStr(item.tarih) : "",
      son_islem_tarihi: item.son_islem_tarihi
          ? this.$helper.tarihStr(item.son_islem_tarihi)
          : "",
      gecen_gun_sayisi: this.calculateDaysPassed(item.son_islem_tarihi),
    }));
  }

  get exportItems(): any[] {
    return this.secilenDosyalar.length > 0 ? this.secilenDosyalar : this.tableItems;
  }

  get excelFileName(): string {
    return `uyarilar-${this.selectedWarningId}.xls`;
  }

  get kesinlesmeDisabled(): boolean {
    return this.selectedWarningId === OfisProUyarilar.dosyaninKesinlestirilmesiTalebi;
  }

  get tooltip(): string {
    if (!this.hasEIcraProLicense) {
      return "Toplu kesinleştirme talebi için E-İcraPro lisansı gereklidir.";
    }
    if (this.secilenDosyalar.length === 0) {
      return "Önce en az bir dosya seçiniz.";
    }
    return "Toplu kesinleştirme talebi gönder";
  }

  get hasEIcraProLicense(): boolean {
    const licenses = this.$store.getters.licenses || [];
    return licenses.some((license: any) => license.id === 3);
  }

  get lisanslar(): boolean {
    return !this.hasEIcraProLicense || this.secilenDosyalar.length === 0;
  }

  mounted() {
    this.handleItems(this.selectedWarningId);
    this.fetchStats();
  }

  beforeDestroy() {
    if (this.searchTimer !== null) {
      window.clearTimeout(this.searchTimer);
    }
  }

  private warningNode(id: number): WarningNode {
    return {
      id,
      name: OfisProUyarilarLabel[id],
      children: [],
    };
  }

  @Watch("search")
  onSearchChanged() {
    if (this.searchTimer !== null) {
      window.clearTimeout(this.searchTimer);
    }

    this.searchTimer = window.setTimeout(() => {
      if (!this.currentWarningType) {
        return;
      }
      this.currentPage = 1;
      this.lastLoadedPage = 0;
      this.fetchWarnings(this.currentWarningType, 1);
    }, 400);
  }

  async fetchWarnings(warningType: string, page = 1) {
    const requestId = ++this.requestSerial;
    this.loading = true;

    try {
      const query = [
        `page=${page}`,
        `per_page=${this.itemsPerPage}`,
        `search=${encodeURIComponent(this.search.trim())}`,
        `sort_by=${encodeURIComponent(this.sortBy)}`,
        `sort_desc=${this.sortDesc ? 1 : 0}`,
      ].join("&");
      const response: any = await this.$http.get(`/api/v1/uyarilar/${warningType}?${query}`);
      const payload = response && response.data && Array.isArray(response.data.data)
          ? response.data
          : response;

      if (requestId !== this.requestSerial) {
        return;
      }

      if (payload && Array.isArray(payload.data)) {
        this.tableItems = payload.data;
        this.totalItems = Number(payload.total || 0);
        this.currentPage = Number(payload.current_page || page);
        this.lastLoadedPage = this.currentPage;
      } else {
        this.tableItems = [];
        this.totalItems = 0;
        this.lastLoadedPage = page;
      }
    } catch (error) {
      if (requestId === this.requestSerial) {
        this.tableItems = [];
        this.totalItems = 0;
        this.$toast.error("Uyarılar yüklenirken bir hata oluştu.");
      }
    } finally {
      if (requestId === this.requestSerial) {
        this.loading = false;
      }
    }
  }

  async fetchStats() {
    try {
      const response: any = await this.$http.get("/api/v1/uyarilar/toplam-sayilar");
      this.stats = response && response.data && response.data.tebligat_uyarilari_detay
          ? response.data
          : (response || {});
    } catch (error) {
      this.stats = {};
    }
  }

  async onOptionsChange(options: any) {
    if (!this.currentWarningType) {
      return;
    }

    const requestedPerPage = Number(options.itemsPerPage || this.itemsPerPage);
    const requestedPage = Number(options.page || 1);
    const requestedSortBy = Array.isArray(options.sortBy) && options.sortBy.length > 0
        ? String(options.sortBy[0])
        : "";
    const requestedSortDesc = Array.isArray(options.sortDesc) && options.sortDesc.length > 0
        ? Boolean(options.sortDesc[0])
        : false;

    if (requestedSortBy !== this.sortBy || requestedSortDesc !== this.sortDesc) {
      this.sortBy = requestedSortBy;
      this.sortDesc = requestedSortDesc;
      this.currentPage = 1;
      this.lastLoadedPage = 0;
      await this.fetchWarnings(this.currentWarningType, 1);
      return;
    }

    if (requestedPerPage !== this.itemsPerPage) {
      this.itemsPerPage = requestedPerPage;
      this.currentPage = 1;
      this.lastLoadedPage = 0;
      await this.fetchWarnings(this.currentWarningType, 1);
      return;
    }

    if (!this.loading && requestedPage !== this.lastLoadedPage) {
      await this.fetchWarnings(this.currentWarningType, requestedPage);
    }
  }

  async handleItems(id: number) {
    const warningType = this.warningTypeMap[id];
    if (!warningType) {
      return;
    }

    this.selectedWarningId = id;
    this.currentWarningType = warningType;
    this.secilenDosyalar = [];
    this.currentPage = 1;
    this.lastLoadedPage = 0;
    await this.fetchWarnings(warningType, 1);
  }

  handleSubCategoryClick(id: number, categoryIndex: number) {
    this.panel = categoryIndex;
    this.activeCategoryId = this.items[categoryIndex].id;
    this.handleItems(id);
  }

  onAccordionChange(panelIndex: number | null) {
    this.activeCategoryId = panelIndex === null || panelIndex === undefined
        ? null
        : this.items[panelIndex].id;
  }

  getItemCount(itemId: number): string {
    if (itemId === OfisProUyarilar.tebligatUyarilari) {
      return String(this.stats.tebligat_uyarilari_toplam || 0);
    }
    if (itemId === OfisProUyarilar.hacizUyarilari) {
      return String(this.stats.haciz_uyarilari_toplam || 0);
    }
    if (itemId === OfisProUyarilar.islemsizliktenDusecekDosyalar) {
      return String(this.stats.islemsizlikten_dusecek_dosyalar || 0);
    }

    const tebligatMapping: {[key: number]: string} = {
      [OfisProUyarilar.adresArastirmaYapilacaklar]: "adres_arastirma",
      [OfisProUyarilar.barkodSorgusuVeTebligatBilgisi]: "barkod_sorgusu",
      [OfisProUyarilar.dosyaninKesinlestirilmesiTalebi]: "kesinlestirme",
      [OfisProUyarilar.gonderildigiTarihGirilecekler]: "gonderildigi_tarih",
      [OfisProUyarilar.hacizTalebindeBulunulacakDosyalar]: "haciz_talebinde_bulunulacak_dosyalar",
      [OfisProUyarilar.itirazinIptaliKaldirilmasiDavasi]: "itiraz_davasi",
      [OfisProUyarilar.malBeyanindaBulunmamaDavasi]: "mal_beyani",
      [OfisProUyarilar.mernisAdresineTebligat]: "mernis",
      [OfisProUyarilar.mersisAdresineTebligat]: "mersis",
      [OfisProUyarilar.otuzBeseGoreTebligat]: "otuzbes_gore",
      [OfisProUyarilar.yirmiBireGoreTebligat]: "yirmibir_gore",
    };
    const hacizMapping: {[key: number]: string} = {
      [OfisProUyarilar.haczeGidilecekDosyalar]: "hacze_gidilecek_dosyalar",
      [OfisProUyarilar.hacizTarihiGirilecekDosyalar]: "haciz_tarihi_girilecek_dosyalar",
      [OfisProUyarilar.seksenDokuzIkiIhbarnamesi]: "seksen_dokuz_iki_ihbarnamesi_gonderilecekler",
      [OfisProUyarilar.seksenDokuzUcIhbarnamesi]: "seksen_dokuz_uc_ihbarnamesi_gonderilecekler",
      [OfisProUyarilar.maasHacziMuzekkeresi]: "maas_haczi_muzekkeresi_gonderilecekler",
      [OfisProUyarilar.muzekkereTebligiKontrol]: "muzekkere_tebligi_kontrol_edilecekler",
      [OfisProUyarilar.yuzUcDavetiyesi]: "yuz_uc_davetiyesi_gonderilecekler",
      [OfisProUyarilar.kiymetTakdiriIstenecekler]: "kiymet_takdiri_istenecekler",
    };

    const tebligatKey = tebligatMapping[itemId];
    if (tebligatKey) {
      return String((this.stats.tebligat_uyarilari_detay || {})[tebligatKey] || 0);
    }

    const hacizKey = hacizMapping[itemId];
    return hacizKey
        ? String((this.stats.haciz_uyarilari_detay || {})[hacizKey] || 0)
        : "0";
  }

  async printTable() {
    const pageItems = this.tableItems;

    try {
      if (this.secilenDosyalar.length > 0) {
        this.tableItems = [...this.secilenDosyalar];
        await this.$nextTick();
      }
      this.$helper.printComponent("uyarilar-tablosu", true, true);
    } finally {
      this.tableItems = pageItems;
    }
  }

  getTakipDetay(item: any) {
    if (!item.takip_id) {
      return;
    }
    this.$router.push(ProgramPaths.icrapro + "/takip/" + item.takip_id);
  }

  calculateDaysPassed(sonIslemTarihi: string): number {
    if (!sonIslemTarihi) {
      return 0;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const lastActionDate = new Date(sonIslemTarihi);
    lastActionDate.setHours(0, 0, 0, 0);
    return Math.max(0, Math.floor(
        (today.getTime() - lastActionDate.getTime()) / (1000 * 60 * 60 * 24),
    ));
  }

  async allCreateTask() {
    const tasks: Task[] = [];

    this.secilenDosyalar.forEach((item: any) => {
      if (!item.borclu || !item.borclu.takip) {
        return;
      }

      const borcluBilgileri = {
        adi: item.borclu.kisi ? item.borclu.kisi.ad : null,
        soyadi: item.borclu.kisi ? item.borclu.kisi.soyad : null,
        kurumAdi: item.borclu.kurum ? item.borclu.kurum.sirket_adi : null,
      };
      const borcluData = item.borclu.kisi
          ? {
            id: item.borclu.id,
            borcluBilgileri,
            tc: item.borclu.kisi.tc_kimlik_no,
            vergi_kimlik: null,
            mersis_no: null,
          }
          : {
            id: item.borclu.id,
            borcluBilgileri,
            tc: null,
            vergi_kimlik: item.borclu.kurum ? item.borclu.kurum.vergi_no : null,
            mersis_no: item.borclu.kurum ? item.borclu.kurum.mersis_no : null,
          };

      const task = new Task();
      task.dosya_esas_no = item.borclu.takip.dosya_esas_no;
      task.birim_adi = item.borclu.takip.icra_dairesi.isim;
      task.dosya_id = String(item.borclu.takip.id);
      task.task_type_id = TaskTuru.toplu_genel_talep_hazirla;
      task.data = {
        params: {
          hacizParams: {},
          digerTalepParams: [{
            grupKodu: 2,
            talepKodu: 31,
            talepAdi: "Takibin Kesinleşmesi",
            talepKisaAdi: "Takibin Kesinleşmesi",
            talepMasrafi: 0,
            className: "AvukatTalepGenelTakibiKesinlestirDVO",
            postaMasrafId: 0,
            dosyaDurum: "A",
          }],
        },
        borclu: borcluData,
        isKisiBool: !!item.borclu.kisi,
      };
      tasks.push(task);
    });

    if (tasks.length === 0) {
      this.$toast.warning("İşlem yapılabilecek bir dosya seçiniz.");
      return;
    }

    await this.$store.dispatch("postTasks", tasks);
    await this.$router.push(ProgramPaths.eicrapro + "/islemler");
  }
}
